import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const retrieveSfg20Differences = api(
    ({
        regimeId,
        skip,
        take,
        sort,
        addedSkip = skip,
        addedTake = take,
        removedSkip = skip,
        removedTake = take,
        changedSkip = skip,
        changedTake = take,
    }) =>
        query(
            gql`
                query RetrieveSFG20Differences(
                    $regimeId: String!
                    $addedSkip: Int
                    $sort: [String]
                    $addedTake: Int
                    $removedSkip: Int
                    $removedTake: Int
                    $changedSkip: Int
                    $changedTake: Int
                ) {
                    regimeDifferences(regimeId: $regimeId, sort: $sort) {
                        id
                        differencesToCurrentSFG20 {
                            id
                            total
                            formerMinutes
                            currentMinutes
                            added {
                                id
                                minutes
                                summarise(by: ["classification"]) {
                                    summary(take: 1000) {
                                        key
                                        value
                                        count
                                    }
                                }
                                tasks {
                                    id
                                    total
                                    items(skip: $addedSkip, take: $addedTake) {
                                        id
                                        taskId
                                        where
                                        classification
                                        code
                                        scheduleTitle
                                        schedule {
                                            _id
                                            id
                                            code
                                            version
                                        }

                                        title
                                        tag
                                        assetIndex
                                        assetId
                                        systemAssets

                                        frequency {
                                            label
                                        }
                                        skill
                                        minutes
                                        count
                                        annualMinutes
                                    }
                                }
                            }
                            removed {
                                id
                                minutes
                                summarise(by: ["classification"]) {
                                    summary(take: 1000) {
                                        key
                                        value
                                        count
                                    }
                                }
                                tasks {
                                    id
                                    total
                                    items(skip: $removedSkip, take: $removedTake) {
                                        id
                                        taskId
                                        where
                                        classification
                                        code
                                        scheduleTitle
                                        title
                                        tag
                                        assetIndex
                                        assetId
                                        schedule {
                                            _id
                                            id
                                            code
                                            version
                                        }
                                        systemAssets

                                        frequency {
                                            label
                                        }
                                        skill
                                        minutes
                                        count
                                        annualMinutes
                                    }
                                }
                            }
                            changed {
                                id
                                minutes
                                summarise(by: ["classification"]) {
                                    summary(take: 1000) {
                                        key
                                        value
                                        count
                                    }
                                }
                                tasks {
                                    id
                                    total
                                    items(skip: $changedSkip, take: $changedTake) {
                                        id
                                        taskId
                                        where
                                        classification
                                        code
                                        scheduleTitle
                                        title
                                        tag
                                        assetIndex
                                        assetId
                                        schedule {
                                            _id
                                            id
                                            code
                                            version
                                        }
                                        systemAssets

                                        frequency {
                                            label
                                        }
                                        skill
                                        minutes
                                        count
                                        annualMinutes
                                        changeInMinutes
                                    }
                                }
                            }
                        }
                    }
                }
            `,
            { regimeId, addedSkip, addedTake, changedSkip, changedTake, removedSkip, removedTake, sort },
            {
                returns: "regimeDifferences.differencesToCurrentSFG20",
            }
        )
)
